import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { Routes, Route, useLocation } from "react-router-dom";
import "@fortawesome/fontawesome-free/css/all.min.css";
import Login from "./components/frontend/auth/Login";
import Register from "./components/frontend/auth/Register";
import Password from "./components/frontend/auth/Password";
import AdminHome from "./components/frontend/AdminHome.js";
import ResetPassword from "./components/frontend/auth/ResetPassword";
import WebsiteHome from "../src/websitecomponents/pages/Home";
import MasterLayout from "../src/layout/admin/MasterLayout";
import { Provider } from "react-redux";
import store from "./websitecomponents/redux/store";
import { ToastContainer } from "react-toastify";
import NavbarScreen from "./websitecomponents/pages/NavBar/NavbarScreen";
import AllProductData from "./websitecomponents/pages/AllProductData";
import Cart from "./websitecomponents/pages/cart";
import AboutUs from "./websitecomponents/pages/AboutUs";
import ContactUs from "./websitecomponents/pages/ContactUs";
import OrderPlace from "./websitecomponents/pages/OrderPlace";
import Wishlist from "./websitecomponents/pages/Wishlist";
import Checkout from "./websitecomponents/pages/Checkout";
import Profile from "./components/admin/Profile";
import WebLogin from "./websitecomponents/pages/Login";
import WebRegister from "./websitecomponents/pages/NavBar/Register";
import ReturnPolicy from "./websitecomponents/FooterInformation.jsx/ReturnPolicy";
import Delivery from "./websitecomponents/FooterInformation.jsx/Delivey";
import ShippingPolicy from "./websitecomponents/FooterInformation.jsx/ShippingPolicy";
import PaymentPolicy from "./websitecomponents/FooterInformation.jsx/PaymentsPolicy";
import DisclaimerPolicy from "./websitecomponents/FooterInformation.jsx/DisclaimerPolicy";
import PrebookingPolicy from "./websitecomponents/FooterInformation.jsx/PrebookingPolicy";
import RefundReturn from "./websitecomponents/FooterInformation.jsx/Refund&Return";
import PrivacyPolicy from "./websitecomponents/FooterInformation.jsx/PrivacyPolicy";
import FAQ from "./websitecomponents/FooterInformation.jsx/FAQ";
import UseIt from "./websitecomponents/FooterInformation.jsx/UseIt";
import TermsOfServices from "./websitecomponents/FooterInformation.jsx/TermsOfServices";
import AllOrders from "./websitecomponents/pages/AllOrder";
import SellerRegister from "./websitecomponents/pages/SellerPages/SellerRegister";
import SellerLogin from "./websitecomponents/pages/SellerPages/SellerLogin";
import ResellerLogin from "./websitecomponents/pages/ReSellerPages/ReSellerLogin.jsx";
import ResellerRegister from "./websitecomponents/pages/ReSellerPages/ReSellerRegister.jsx";
import ThankYouPage from "./websitecomponents/pages/ThankYouPage";
import TopSellDetails from "./websitecomponents/pages/TopSellDetails";
import CancelAndReturn from "./websitecomponents/FooterInformation.jsx/cancelandreturn";
import ProductDetails from "./websitecomponents/pages/productdetails";
import ShowSubCategory from "./websitecomponents/pages/Categories/ShowSubCategory";
import ViewAllCategory from "./websitecomponents/pages/Categories/ViewAllCategory";
import ShowCategoryData from "./websitecomponents/pages/Categories/ShowCategoryData";
import { v4 as uuidv4 } from "uuid";
import Address from "./websitecomponents/pages/address";
import Getaddress from "./websitecomponents/pages/getaddress";
import Coupons from "./websitecomponents/pages/Coupons";
import OtpScreen from "./websitecomponents/pages/otpscreen";
import TitleManager from "./websitecomponents/pages/titlemaneger";
import GetcategorySubcategory from "./websitecomponents/pages/getcategorysubcategory";
import ViewAllBrand from "./websitecomponents/pages/viewAllBrand";
import ShowBrandData from "./websitecomponents/pages/showBrandData";
import EditProducts from "./components/admin/products/EditProducts";
import EditCategory from "./components/admin/category/EditCategory";
import SuccessPagePayment from "./websitecomponents/pages/SuccessPage.jsx";
import OrderSuccess from "./websitecomponents/pages/OrderSuccess.jsx";
import PaymentFailed from "./websitecomponents/pages/PaymentFailed.jsx";
import SellerForgotPassword from "./websitecomponents/pages/SellerPages/SellerForgotPassword.jsx";
import SellerResetPassword from "./websitecomponents/pages/SellerPages/SellerResetPassword.jsx";
import SellerDashboard from "./Seller/SellerDashboard.jsx";
import SellerProfile from "./Seller/SellerProfile.jsx";
import SellerLayout from "./Seller/SellerLayout.jsx";
import EditProfile from "./Seller/EditProfile.jsx";
import NewOrder from "./Seller/Orders/NewOrder.jsx";
import AddProduct from "./Seller/Products/AddProduct.jsx";
import ViewProduct from "./Seller/Products/ViewProdcut.jsx";
import Wallet from "./Seller/Orders/Wallet.jsx";
import GetWithdrowRequest from "./Seller/Orders/GetWithdrowRequest.jsx";
import ReSellerDashboard from "./ReSeller/ReSellerDashboard.jsx";
import ReSellerProfile from "./ReSeller/ReSellerProfile.jsx";
import ReSellerLayout from "./ReSeller/ReSellerLayout.jsx";
import ReSellerEditProfile from "./ReSeller/EditProfile.jsx";

import ReSellerOrders from "./ReSeller/Orders/Orders.jsx";

import ReSellerViewProducts from "./ReSeller/Products/ViewProduct.jsx";
import ResellProduct from "./ReSeller/Products/ResellProduct.jsx";
import MyProduct from "./ReSeller/Products/MyProduct.jsx";
import ResellerProductDetails from "./websitecomponents/pages/ResellerProductDetails.jsx";
import ResellerWallet from "./ReSeller/Orders/Wallet.jsx";
import GetReWithdrowRequest from "./ReSeller/Orders/GetReWithdrowRequest.jsx";

function App() {
  const location = useLocation();

  useEffect(() => {
    const EXPIRY_LIMIT = 2 * 60 * 60 * 1000;
    const now = Date.now();

    const token = localStorage.getItem("authToken");
    const uuid = localStorage.getItem("uuid");
    const uuidTime = localStorage.getItem("uuidTime");

    if (
      !token &&
      (!uuid || !uuidTime || now - parseInt(uuidTime) > EXPIRY_LIMIT)
    ) {
      const newUuid = uuidv4();
      localStorage.setItem("uuid", newUuid);
      localStorage.setItem("uuidTime", now.toString());
      window.location.reload();
    }
  }, []);

  useEffect(() => {
    const EXPIRY_LIMIT = 24 * 60 * 60 * 1000;
    const now = Date.now();

    const token = localStorage.getItem("authToken");
    const tokenTime = localStorage.getItem("authTokenTime");

    if (token && tokenTime) {
      if (now - parseInt(tokenTime) > EXPIRY_LIMIT) {
        localStorage.removeItem("authToken");
        localStorage.removeItem("authTokenTime");
        localStorage.removeItem("userId");
        localStorage.removeItem("orderID");
        localStorage.removeItem("uuid");
        localStorage.removeItem("uuidTime");
        window.location.reload();
      }
    }
  }, []);

  useEffect(() => {
    const isAdminRoute = location.pathname.startsWith("/admin");
    const isSellerRoute = location.pathname.startsWith("/seller/dashboard");

    if (isAdminRoute) {
      localStorage.removeItem("authToken");
      window.location.href = "/bharatcod-admin";
    }
    if (isSellerRoute) {
      localStorage.removeItem("SellerTokenData");
      window.location.href = "/SellerLogin";
    }
  }, []);

  const hideNavbarRoutes = [
    "/bharatcod-admin",
    "/Register",
    "/Login",
    "/Password",
    "/ResetPassword",
    "/admin",
    "/seller",
    "/reseller",
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // If you want to also hide it for any route starting with /admin
  const shouldHideNavbar = hideNavbarRoutes.some((path) =>
    location.pathname.startsWith(path),
  );

  return (
    <div className="App">
      <Helmet>
        <script
          async
          src="https://www.googletagmanager.com/gtag/js?id=G-1T17EG7TVZ"
        ></script>
        <script>
          {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'G-1T17EG7TVZ');
          `}
        </script>
      </Helmet>
      <ToastContainer />
      <Provider store={store}>
        {!shouldHideNavbar && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              zIndex: 10,
              backgroundColor: "white",
              borderBottom: "1px solid lightgray",
            }}
          >
            <NavbarScreen />
          </div>
        )}

        <TitleManager />
        <div style={{ marginTop: shouldHideNavbar ? "0px" : "75px" }}>
          <Routes>
            <Route path="/" element={<WebsiteHome />} />
            <Route path="/bharatcod-admin" element={<AdminHome />} />
            <Route path="Register" element={<Register />} />
            <Route path="Login" element={<Login />} />
            <Route path="Password" element={<Password />} />
            <Route path="ResetPassword" element={<ResetPassword />} />
            <Route path="admin/*" element={<MasterLayout />} />
            <Route path="/admin/edit/:id" element={<EditProducts />} />
            <Route path="/admin/EditCategory/:id" element={<EditCategory />} />
            <Route path="AllProductData" element={<AllProductData />} />
            <Route path="/Cart" element={<Cart />} />
            <Route path="/about-us/" element={<AboutUs />} />
            <Route path="/contact-us/" element={<ContactUs />} />
            <Route path="/OrderPlace" element={<OrderPlace />} />
            <Route path="/Wishlist" element={<Wishlist />} />
            <Route path="/Checkout" element={<Checkout />} />
            <Route path="/Address" element={<Address />} />
            <Route
              path="/GetcategorySubcategory"
              element={<GetcategorySubcategory />}
            />
            <Route path="/Profile" element={<Profile />} />
            <Route path="/my-account/" element={<WebLogin />} />
            <Route path="/Register" element={<WebRegister />} />
            <Route path="/return-policy/" element={<ReturnPolicy />} />
            <Route path="/delivery-information/" element={<Delivery />} />
            <Route path="/shipping-policy/" element={<ShippingPolicy />} />
            <Route
              path="/pricing-and-payments-policy/"
              element={<PaymentPolicy />}
            />
            <Route path="/disclaimer-policy/" element={<DisclaimerPolicy />} />
            <Route
              path="/prebooking-terms-and-conditions/"
              element={<PrebookingPolicy />}
            />
            <Route path="/refund-return/" element={<RefundReturn />} />
            <Route path="/terms-of-service/" element={<TermsOfServices />} />
            <Route path="/privacy-policy-2/" element={<PrivacyPolicy />} />
            <Route path="/faq/" element={<FAQ />} />
            <Route path="/how-to/" element={<UseIt />} />
            <Route path="/track-your-order/" element={<AllOrders />} />
            <Route path="/SellerRegister" element={<SellerRegister />} />
            <Route path="/SellerLogin" element={<SellerLogin />} />
            <Route path="/ResellerRegister" element={<ResellerRegister />} />
            <Route path="/ResellerLogin" element={<ResellerLogin />} />
            <Route path="/ThankYouPage" element={<ThankYouPage />} />
            <Route path="/TopSellDetails" element={<TopSellDetails />} />
            <Route path="/offers" element={<Coupons />} />
            <Route
              path="/cancellation-and-return-policy/"
              element={<CancelAndReturn />}
            />
            <Route
              path="/category/:category/:subcategory/"
              element={<ShowSubCategory />}
            />
            <Route
              path="/category/:category/:title/:id"
              element={<ProductDetails />}
            />
            {/* <Route
              path="/reseller-product/:id"
              element={<ResellerProductDetails />}
            /> */}
            <Route
              path="/product/reseller/:id"
              element={<ResellerProductDetails />}
            />
            <Route path="/ViewAllCategory" element={<ViewAllCategory />} />
            <Route
              path="/ShowCategoryData/:category?/:id/:subCategoryName?"
              element={<ShowCategoryData />}
            />
            <Route path="/Getaddress" element={<Getaddress />} />
            <Route path="/OtpScreen" element={<OtpScreen />} />
            <Route path="/ViewAllBrand" element={<ViewAllBrand />} />
            <Route path="/:brand/:id/:name?" element={<ShowBrandData />} />
            <Route path="/PaymentResult" element={<SuccessPagePayment />} />
            <Route path="/order-success" element={<OrderSuccess />} />
            <Route path="/payment-failed" element={<PaymentFailed />} />
            <Route path="/SellerForgot" element={<SellerForgotPassword />} />
            <Route
              path="/SellerResetPassword"
              element={<SellerResetPassword />}
            />

            {/* <Route path="/seller" element={<SellerLayout />}> */}
            <Route
              path="/seller/*"
              element={
                localStorage.getItem("SellerTokenData") ? (
                  <SellerLayout />
                ) : (
                  <SellerLogin />
                )
              }
            >
              <Route index element={<SellerDashboard />} /> {/* /seller */}
              <Route path="dashboard" element={<SellerDashboard />} />
              <Route path="profile" element={<SellerProfile />} />
              <Route path="editProfile" element={<EditProfile />} />
              <Route path="newOrder" element={<NewOrder />} />
              <Route path="addProduct" element={<AddProduct />} />
              <Route path="viewProduct" element={<ViewProduct />} />
              <Route path="wallet" element={<Wallet />} /> {/* Wallet route */}
              <Route path="withdrawRequests" element={<GetWithdrowRequest />} />
            </Route>
            {/* Withdraw Requests */}
            {/* <Route path="/reseller/*" element={<ReSellerLayout />}> */}
            <Route
              path="/reseller/*"
              element={
                localStorage.getItem("ResellerTokenData") ? (
                  <ReSellerLayout />
                ) : (
                  <ResellerLogin />
                )
              }
            >
              <Route index element={<ReSellerDashboard />} />
              <Route path="dashboard" element={<ReSellerDashboard />} />
              <Route path="profile" element={<ReSellerProfile />} />
              <Route path="editProfile" element={<ReSellerEditProfile />} />
              <Route path="orders" element={<ReSellerOrders />} />

              <Route path="viewProduct" element={<ReSellerViewProducts />} />
              <Route path="ResellProduct/:id" element={<ResellProduct />} />
              <Route path="MyProduct" element={<MyProduct />} />
              <Route path="wallet" element={<ResellerWallet />} />
              <Route
                path="GetReWithdrowRequest"
                element={<GetReWithdrowRequest />}
              />

              {/* ResellerProductDetails */}
            </Route>
          </Routes>
        </div>
      </Provider>
    </div>
  );
}

export default App;
